export default __webpack_public_path__ + "static/media/cm-1.16be2229.jpg";